export default __webpack_public_path__ + "static/media/img-slider-token-5.3dc31fe7.png";